module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_3009.b07d5d84.png";